import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  Text,
  Spinner,
  FormHelperText,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { componentState } from "../../../atoms/componentState";
import {
  BLUEMONEDDBUTTONS,
  GRAY_DARK,
  REDMONEDD,
  WHITE,
} from "../../../constants/colors";
import { useSetRecoilState } from "recoil";
import TitleFlex from "./components/titleFlex";
import { NumericFormat, PatternFormat } from "react-number-format";
import { stateOptions } from "../../../constants/stateOptions";
import moment from "moment";
import { dateForAPI, dateForValueInput } from "../../../constants/dataFormat";
import {
  cnpj,
  cnpj as cnpjValidator,
  cpf as cpfValidator,
} from "cpf-cnpj-validator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import VendasBoletoApi from "../../../services/VendasBoletoApi";
import ModalRevisãoVendaBoleto from "./components/ModalRevisãoVendaBoleto";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { goToVendaBoletoListagem } from "../../../routes/coordinator";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";
import { useRecoilState } from "recoil";

export interface VendaBoleto {
  idCliente: number;
  valor: number;
  vencimento: string;
  descricao: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  RegrasJuros: {
    mode: string;
    amount: number; //somente se selecionar um valor fixo
    percentage: number; //somente se selecionar uma opção de juros em porcentagem
    start_date: string;
  };
  RegrasMulta: {
    mode: string;
    amount: number; //somente se selecionar um valor fixo
    percentage: number; //somente se selecionar uma opção de juros em porcentagem
    start_date: string;
  };
}

export default function VendasBoleto() {
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Venda no Boleto");
  }, []);
  const navigate = useNavigate();
  // const colors = useRecoilState(customColors)[0];

  const token = window.localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  let jwtToken: JWTToken = jwt_decode(token || "");
  // const cliente = Number(jwtToken.idCliente);
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const cliente =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);

  // const [cliente, setCliente] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const unMask = (value: any) => {
    if (typeof value !== "string") {
      return "";
    }
    return value.replace(/[^0-9]/g, "");
  };

  const initialValues = {
    idCliente: 0,
    valor: 0,
    vencimento: "",
    descricao: "",
    cpfPagador: "",
    nomePagador: "",
    emailPagador: "",
    enderRua: "",
    enderBairro: "",
    enderCEP: "",
    enderCidade: "",
    enderComplemento: "",
    enderEstado: "AC",
    enderNumero: "",
    enderReferencia: "",
    permitirRegras: false,
    RegrasJuros: {
      mode: "SEM_JUROS",
      amount: 0, //somente se selecionar um valor fixo
      percentage: 0, //somente se selecionar uma opção de juros em porcentagem
      start_date: "", // o memso que a data de vencimento
    },
    RegrasMulta: {
      mode: "SEM_MULTA",
      amount: 0, //somente se selecionar um valor fixo
      percentage: 0, //somente se selecionar uma opção de juros em porcentagem
      start_date: "", // o memso que a data de vencimento
    },
  };

  /*   const [boleto, setBoleto] = useState<VendaBoleto>(initialValues); */
  const [boleto, setBoleto] = useState(initialValues);

  function onChangeValorFixo(e: any) {
    setBoleto({
      ...boleto,
      valor: Number(e.target.value.slice(3).replace(",", ".")),
    });
  }

  const [responseToModal, setResponseToModal] = useState();
  const [objetoModal, setObjetoModal] = useState();
  const [isOpen, setIsOpen] = useState(false);

  async function onSubmit() {
    const valorMinimo = boleto.permitirRegras ? 10 : 5;
    if (parseFloat(boleto.valor.toString().replace(",", ".")) < valorMinimo) {
      toast.error(
        `O boleto deve ter um valor maior que R$ ${valorMinimo.toFixed(2)}!`
      );
      return;
    }

    const maxDailyPercentage = parseFloat((boleto.valor * 0.033).toFixed(2));
    const maxFixedPenalty = parseFloat((boleto.valor * 0.02).toFixed(2));

    if (
      (boleto.RegrasJuros.mode === "DAILY_PERCENTAGE" &&
        (boleto.RegrasJuros.percentage <= 0 ||
          boleto.RegrasJuros.percentage > maxDailyPercentage)) ||
      (boleto.RegrasJuros.mode === "MONTHLY_PERCENTAGE" &&
        (boleto.RegrasJuros.percentage <= 0 ||
          boleto.RegrasJuros.percentage > 1)) ||
      (boleto.RegrasMulta.mode === "PERCENTAGE" &&
        (boleto.RegrasMulta.percentage <= 0 ||
          boleto.RegrasMulta.percentage > 2)) ||
      (boleto.RegrasMulta.mode === "FIXED" &&
        (boleto.RegrasMulta.amount < 0 ||
          boleto.RegrasMulta.amount > maxFixedPenalty))
    ) {
      toast.error("Os valores de juros e multa estão fora do permitido.");
      return;
    }

    const objeto = {
      idCliente: cliente,
      valor: boleto.valor,
      vencimento: boleto.vencimento,
      descricao: boleto.descricao,
      cpfPagador: unMask(boleto.cpfPagador),
      nomePagador: boleto.nomePagador,
      emailPagador: boleto.emailPagador,
      enderRua: boleto.enderRua,
      enderBairro: boleto.enderBairro,
      enderCEP: unMask(boleto.enderCEP),
      enderCidade: boleto.enderCidade,
      enderComplemento: boleto.enderComplemento,
      enderEstado: boleto.enderEstado,
      enderNumero: boleto.enderNumero,
      enderReferencia: boleto.enderReferencia,
      permitirRegras: boleto.permitirRegras,
      RegrasJuros: {
        mode: boleto.RegrasJuros.mode,
        amount: boleto.RegrasJuros.amount,
        percentage: boleto.RegrasJuros.percentage,
        start_date: boleto.vencimento,
      },
      RegrasMulta: {
        mode: boleto.RegrasMulta.mode,
        amount: boleto.RegrasMulta.amount,
        percentage: boleto.RegrasMulta.percentage,
        start_date: boleto.vencimento,
      },
    };

    try {
      setLoading(true); // Ativa o loading
      await postPayment(objeto);
    } catch (error) {
      console.error("Erro ao enviar pagamento:", error);
      toast.error("Erro ao processar o pagamento.");
    } finally {
      setLoading(false); // Sempre desativa o loading
    }
  }

  async function postPayment(obj: any) {
    setIsLoading(true);
    try {
      setObjetoModal(obj);
      const response = await VendasBoletoApi.postVendaDigitada(obj);
      setResponseToModal(response);
      setIsOpen(true);

      setBoleto(initialValues);
      toast.success("Boleto criado com sucesso!");
    } catch (error: any) {
      setIsOpen(false);

      if (error.response && error.response.data && error.response.data._error) {
        const errorDetails = error.response.data._error.error;
        toast.error(
          `Erro na requisição: ${JSON.stringify(errorDetails, null, 2)}`
        );
      } else {
        toast.error("Não foi possível cadastrar o boleto para pagamento!");
      }
    } finally {
      setIsLoading(false);
    }
  }

  const [validation, setValidation] = useState(false);

  function validateCPForCNPJ(item: any) {
    const temp = unMask(item);
    if (temp.length === 11) {
      if (cpfValidator.isValid(temp) === false) {
        setValidation(true);
      } else {
        setValidation(false);
      }
    } else {
      if (cnpjValidator.isValid(temp) === false) {
        setValidation(true);
      } else {
        setValidation(false);
      }
    }
  }
  const valorConvertido = parseFloat(boleto.valor.toString().replace(",", "."));

  async function addressCep(cep: any) {
    try {
      if (unMask(cep).length >= 8) {
        let req = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (req.data.erro) {
                  toast.error("CEP não encontrado!");
                  return;
                }

        setBoleto((value) => ({
          ...value,
          enderRua: req.data.logradouro,
          enderBairro: req.data.bairro,
          enderCEP: req.data.cep,
          enderCidade: req.data.localidade,
          enderComplemento: req.data.complemento,
          enderEstado: req.data.uf,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  const validarSeFinalDeSemana = (e: any) => {
    const dia = moment(e.target.value, "YYYY-MM-DD").day();
    const naoFinalDeSemana = dia !== 0 && dia !== 6;

    // const validarData = new Date(e.target.value);
    // const NaoFinalDeSemana =
    //   validarData.getDay() !== 0 && validarData.getDay() !== 6;
    const e_valido = validarMesmoDiaEAntesDasDezesseisHoras(e.target.value);
    if (e_valido) {
      if (true) {
        setBoleto({
          ...boleto,
          vencimento: moment(e.target.value).format(dateForAPI),
        });
      } else {
        toast.error("A data não pode ser um final de semana!");
      }
    } else {
      toast.error(
        "Não é possível realizar solicitações para o mesmo dia após as 16hs!"
      );
    }
  };

  function validarMesmoDiaEAntesDasDezesseisHoras(data: any) {
    const horaDaSolicitacao = moment().format("HH.mm");
    const diadaSolicitação =
      moment().format("DD-MM-YYYY") === moment(data).format("DD-MM-YYYY");
    if (diadaSolicitação) {
      if (Number(horaDaSolicitacao) < 16) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function validaData(item: any) {
    if (moment(item) < moment().startOf("day")) {
      toast.error("A data não pode ser anterior ao dia de hoje!");
    }
  }

  const OPTIONS_INTEREST = [
    { key: 1, value: "SEM_JUROS", text: "Sem juros" },
    { key: 2, value: "DAILY_AMOUNT", text: "Valor diário" },
    { key: 3, value: "DAILY_PERCENTAGE", text: "Percentual diário" },
    { key: 4, value: "MONTHLY_PERCENTAGE", text: "Percentual mensal" },
  ];

  const OPTIONS_MULTA = [
    { key: 1, value: "SEM_MULTA", text: "Sem Multa" },
    { key: 2, value: "FIXED", text: "Valor Fixo" },
    { key: 3, value: "PERCENTAGE", text: "Valor em Porcentagem" },
  ];

  return (
    <Flex
      w={"100%"}
      h={"90vh"}
      bgColor={WHITE}
      px={10}
      pt={4}
      shadow={"lg"}
      overflowY={"scroll"}
      flexDir={"column"}
    >
      <Box mb={"10px"} width={"100%"} height={"fit-content"}>
        <Flex alignItems="center">
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Venda Boleto
          </Text>
        </Flex>
      </Box>
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        justifyContent={"flex-end"}
        px={5}
      >
        {/* <Button bgColor={GRAY} color={WHITE} onClick={() => {}}>
                Voltar
            </Button> */}
      </Flex>
      {/* <TitleFlex item={"Informe o cliente"} />
        <Box w={"25%"}>
            <ClientSelect cliente={cliente} setCliente={setCliente} />
        </Box> */}
      <TitleFlex item={"Informações de pagamento"} />
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
      >
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Valor (valor mínimo de R$ ${boleto.permitirRegras ? "10,00" : "5,00"
            })`}</FormLabel>
          <NumericFormat
            decimalScale={2}
            prefix="R$ "
            value={boleto.valor}
            decimalSeparator=","
            customInput={Input}
            type="text"
            placeholder="R$ 0,00"
            onChange={onChangeValorFixo}
          />
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Data de vencimento`}</FormLabel>
          <Input
            type={"date"}
            value={moment(boleto.vencimento).format(dateForValueInput)}
            min={moment().startOf("day").format(dateForValueInput)}
            onChange={(e: any) => {
              validarSeFinalDeSemana(e);
            }}
            onBlur={(e: any) => {
              validaData(e.target.value);
            }}
          />
        </FormControl>
        <FormControl px={2}>
          <FormLabel>Descrição</FormLabel>
          <Input
            placeholder="Opcional"
            value={boleto.descricao}
            onChange={(e: any) => {
              setBoleto({ ...boleto, descricao: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      <Flex my={2}>
        <Switch
          size="md"
          ml={3}
          mr={3}
          onChange={(e: any) => {
            setBoleto({ ...boleto, permitirRegras: !boleto.permitirRegras });
          }}
        ></Switch>
        <Text fontSize={"14px"}>Aplicar Regras</Text>
      </Flex>
      {boleto.permitirRegras && <TitleFlex item={"Regras do Boleto "} />}
      {boleto.permitirRegras && (
        <>
          <Text fontStyle={"italic"} ml={2}>
            Multa é um valor fixo em R$ ou %, aplicado após o vencimento
          </Text>
          <Text fontStyle={"italic"} ml={2}>
            Juros é um valor em R$ ou %, aplicado diariamente ou mensalmente a
            partir da data de vencimento
          </Text>
          <Text fontStyle={"italic"} ml={2}>
            A contagem de juros e multa, caso houver, se dá a partir da data de
            vencimento do boleto
          </Text>
        </>
      )}
      {boleto.permitirRegras && (
        <Flex
          w={"100%"}
          h={"fit-content"}
          flexDir={"row"}
          my={2}
          alignItems={"end"}
        >
          {/* Regras de Juros */}
          <FormControl px={2} maxWidth={"20%"}>
            <FormLabel>{`Regras de Juros`}</FormLabel>
            <Select
              value={boleto.RegrasJuros.mode}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setBoleto({
                  ...boleto,
                  RegrasJuros: {
                    ...boleto.RegrasJuros,
                    mode: e.target.value,
                  },
                });
              }}
            >
              {OPTIONS_INTEREST.map((item: any) => (
                <option key={item.key} value={item.value}>
                  {item.text}
                </option>
              ))}
            </Select>
          </FormControl>
          {/* Percentual Diário */}
          {boleto.RegrasJuros.mode === "DAILY_PERCENTAGE" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>{`Valor em %`}</FormLabel>
              <FormHelperText color="red.500">{`Valor permitido até ${(
                boleto.valor * 0.00033
              ).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}`}</FormHelperText>

              <NumericFormat
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                customInput={Input}
                value={boleto.RegrasJuros.percentage}
                placeholder="0,000"
                isAllowed={({ floatValue }) => {
                  const valorMaximo = (boleto.valor * 0.033) / 100;
                  return (
                    floatValue === undefined ||
                    (floatValue >= 0 && floatValue <= valorMaximo)
                  );
                }}
                onValueChange={({ value }) => {
                  let inputValue = parseFloat(value.replace(",", "."));
                  const valorMaximo = (boleto.valor * 0.033) / 100;

                  if (isNaN(inputValue) || inputValue > valorMaximo) {
                    inputValue = valorMaximo;
                  }

                  setBoleto({
                    ...boleto,
                    RegrasJuros: {
                      ...boleto.RegrasJuros,
                      percentage: inputValue,
                      amount: 0,
                    },
                  });
                }}
              />
              {boleto.RegrasJuros.percentage > (boleto.valor * 0.033) / 100 && (
                <FormHelperText color="red.500">
                  O valor dos juros diários não pode exceder 0,033% ao dia do
                  valor total do boleto.
                </FormHelperText>
              )}
            </FormControl>
          )}

          {/* Percentual Mensal */}
          {boleto.RegrasJuros.mode === "MONTHLY_PERCENTAGE" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>{`Valor em %`}</FormLabel>
              <FormHelperText color="red.500">{`Valor permitido até 1,00% `}</FormHelperText>
              <NumericFormat
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                customInput={Input}
                value={boleto.RegrasJuros.percentage}
                placeholder="0,00"
                isAllowed={({ floatValue }) => {
                  const valorMaximo = 1;
                  return (
                    floatValue === undefined ||
                    (floatValue >= 0 && floatValue <= valorMaximo)
                  );
                }}
                onValueChange={({ value }) => {
                  let inputValue = parseFloat(value.replace(",", "."));
                  const valorMaximo = 1;

                  if (isNaN(inputValue) || inputValue > valorMaximo) {
                    inputValue = valorMaximo;
                  }

                  setBoleto({
                    ...boleto,
                    RegrasJuros: {
                      ...boleto.RegrasJuros,
                      percentage: inputValue,
                      amount: 0,
                    },
                  });
                }}
              />
              {boleto.RegrasJuros.percentage > 1 && (
                <FormHelperText color="red.500">
                  O valor dos juros mensais não pode exceder 1% ao mês.
                </FormHelperText>
              )}
            </FormControl>
          )}

          {/* Valor Diário */}
          {boleto.RegrasJuros.mode === "DAILY_AMOUNT" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>
                {`Valor em R$ `}
                <FormHelperText color="red.500">{`Valor permitido até ${(
                  boleto.valor * 0.00033
                ).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}`}</FormHelperText>
              </FormLabel>
              <NumericFormat
                decimalScale={2}
                prefix="R$ "
                value={boleto.RegrasJuros.amount}
                decimalSeparator=","
                thousandSeparator="."
                customInput={Input}
                placeholder="R$ 0,00"
                allowNegative={false} // impede valores negativos
                fixedDecimalScale={true} // mantem sempre duas casas decimais
                isAllowed={(values) => {
                  const { floatValue } = values;
                  const valorMaximo = boleto.valor * 0.00033;

                  return (
                    floatValue === undefined ||
                    (floatValue >= 0 && floatValue <= valorMaximo)
                  );
                }}
                onValueChange={({ value }) => {
                  const inputValue = parseFloat(
                    value.replace("R$ ", "").replace(",", ".")
                  );
                  const valorMaximo = boleto.valor * 0.00033;

                  const sanitizedValue = Math.min(
                    Math.max(inputValue ?? 0, 0),
                    valorMaximo
                  );

                  setBoleto({
                    ...boleto,
                    RegrasJuros: {
                      ...boleto.RegrasJuros,
                      amount: sanitizedValue,
                      percentage: 0,
                    },
                  });
                }}
              />
              {boleto.RegrasJuros.amount > boleto.valor * 0.00033 && (
                <FormHelperText color="red.500">
                  O valor dos juros diários não pode exceder 0,033% do valor do
                  boleto.
                </FormHelperText>
              )}
            </FormControl>
          )}

          {/* Sem Juros */}
          {boleto.RegrasJuros.mode === "SEM_JUROS" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>Não aplicar juros</FormLabel>
            </FormControl>
          )}

          {/* Regras de Multa */}
          <FormControl px={2} maxWidth={"20%"}>
            <FormLabel>{`Regra de Multa`}</FormLabel>
            <Select
              value={boleto.RegrasMulta.mode}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setBoleto({
                  ...boleto,
                  RegrasMulta: {
                    ...boleto.RegrasMulta,
                    mode: e.target.value,
                  },
                });
              }}
            >
              {OPTIONS_MULTA.map((item: any) => (
                <option key={item.key} value={item.value}>
                  {item.text}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* Quando não há multa */}
          {boleto.RegrasMulta.mode === "SEM_MULTA" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>Não aplicar multa</FormLabel>
            </FormControl>
          )}

          {/* Valor fixo de multa */}
          {boleto.RegrasMulta.mode === "FIXED" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>{`Valor em R$`}</FormLabel>
              <FormHelperText color="red.500">{`Valor permitido até ${(
                boleto.valor * 0.02
              ).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}`}</FormHelperText>
              <NumericFormat
                decimalScale={2}
                prefix="R$ "
                value={boleto.RegrasMulta.amount}
                decimalSeparator=","
                thousandSeparator="."
                customInput={Input}
                placeholder="R$ 0,00"
                allowNegative={false} // impede valores negativos
                fixedDecimalScale={true} //  sempre duas casas decimais
                isAllowed={(values) => {
                  const { floatValue } = values;
                  const valorMaximo = boleto.valor * 0.02;
                  //  apenas valores até o máximo permitido
                  return (
                    floatValue === undefined ||
                    (floatValue >= 0 && floatValue <= valorMaximo)
                  );
                }}
                onValueChange={({ value }) => {
                  const inputValue = parseFloat(
                    value.replace("R$ ", "").replace(",", ".")
                  );
                  const valorMaximo = boleto.valor * 0.02;

                  const sanitizedValue = Math.min(
                    Math.max(inputValue ?? 0, 0),
                    valorMaximo
                  );

                  setBoleto({
                    ...boleto,
                    RegrasMulta: {
                      ...boleto.RegrasMulta,
                      amount: sanitizedValue,
                      percentage: 0,
                    },
                  });
                }}
              />
              {boleto.RegrasMulta.amount > boleto.valor * 0.02 && (
                <FormHelperText color="red.500">
                  O valor da multa não pode exceder 2% do valor do boleto.
                </FormHelperText>
              )}
            </FormControl>
          )}

          {/* Percentual de multa */}
          {boleto.RegrasMulta.mode === "PERCENTAGE" && (
            <FormControl px={2} maxWidth={"20%"}>
              <FormLabel>{`Valor em %`}</FormLabel>
              <FormHelperText color="red.500">{`Valor permitido até 2,00% `}</FormHelperText>
              <NumericFormat
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                customInput={Input}
                value={boleto.RegrasMulta.percentage}
                placeholder="0,00"
                isAllowed={({ floatValue }) => {
                  const valorMaximo = 2;
                  return (
                    floatValue === undefined ||
                    (floatValue >= 0 && floatValue <= valorMaximo)
                  );
                }}
                onValueChange={({ value }) => {
                  const inputValue = parseFloat(value.replace(",", "."));
                  const valorMaximo = 2;

                  const sanitizedValue =
                    isNaN(inputValue) || inputValue > valorMaximo
                      ? valorMaximo
                      : inputValue;

                  setBoleto({
                    ...boleto,
                    RegrasMulta: {
                      ...boleto.RegrasMulta,
                      percentage: sanitizedValue,
                      amount: 0,
                    },
                  });
                }}
              />
              {boleto.RegrasMulta.percentage > 2 && (
                <FormHelperText color="red.500">
                  O valor da multa percentual não pode exceder 2%.
                </FormHelperText>
              )}
            </FormControl>
          )}
        </Flex>
      )}
      {/* <TitleFlex item={"Regras do boleto"} /> */}
      <TitleFlex item={"Informações do Pagador"} />
      <Flex flexDir={"row"}>
        <FormControl mx={2}>
          <FormLabel>CPF/CNPJ do Pagador</FormLabel>
          <PatternFormat
            customInput={Input}
            format={
              unMask(boleto.cpfPagador).length > 11
                ? "##.###.###/####-##"
                : "###.###.###-###"
            }
            type="text"
            placeholder="Digite o CPF ou CNPJ"
            value={boleto.cpfPagador}
            onChange={(e) => {
              setBoleto({ ...boleto, cpfPagador: e.target.value });
            }}
            onBlur={(e) => {
              validateCPForCNPJ(e.target.value);
            }}
          />
          {validation && (
            <Text color={REDMONEDD}>Digite um CPF ou CNPJ Válido!</Text>
          )}
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>Nome do Pagador</FormLabel>
          <Input
            placeholder={"Digite o nome"}
            name={"name"}
            value={boleto.nomePagador}
            onChange={(e) => {
              setBoleto({ ...boleto, nomePagador: e.target.value });
            }}
          // onFocus={onFocus}
          />
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>E-mail</FormLabel>
          <Input
            placeholder="E-mail do Pagador"
            value={boleto.emailPagador}
            onChange={(e: any) => {
              setBoleto({ ...boleto, emailPagador: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      <TitleFlex item={"Endereço de cobrança"} />
      <Flex flexDir={"row"}>
        <FormControl mx={2} maxW={"18%"}>
          <FormLabel>CEP</FormLabel>
          <PatternFormat
            customInput={Input}
            format={"#####-###"}
            value={boleto.enderCEP}
            onChange={(e) => {
              setBoleto({ ...boleto, enderCEP: e.target.value });
              addressCep(e.target.value);
            }}
          />
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>Endereço</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderRua}
            onChange={(e) => {
              setBoleto({ ...boleto, enderRua: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      <Flex flexDir={"row"}>
        <FormControl mx={2} maxW={"20%"}>
          <FormLabel>Número</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderNumero}
            onChange={(e) => {
              setBoleto({ ...boleto, enderNumero: e.target.value });
            }}
          />
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>Complemento</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderComplemento}
            onChange={(e) => {
              setBoleto({ ...boleto, enderComplemento: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      <Flex flexDir={"row"}>
        <FormControl mx={2} maxW={"35%"}>
          <FormLabel>Referência</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderReferencia}
            onChange={(e) => {
              setBoleto({ ...boleto, enderReferencia: e.target.value });
            }}
          />
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>Bairro</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderBairro}
            onChange={(e) => {
              setBoleto({ ...boleto, enderBairro: e.target.value });
            }}
          />
        </FormControl>
      </Flex>
      <Flex flexDir={"row"}>
        <FormControl mx={2}>
          <FormLabel>Cidade</FormLabel>
          <Input
            type={"text"}
            value={boleto.enderCidade}
            onChange={(e) => {
              setBoleto({ ...boleto, enderCidade: e.target.value });
            }}
          />
        </FormControl>
        <FormControl mx={2} maxW={"35%"}>
          <FormLabel>Estado</FormLabel>
          <Select
            value={boleto.enderEstado}
            onChange={(e) => {
              setBoleto({ ...boleto, enderEstado: e.target.value });
            }}
          >
            {stateOptions.map((item, index) => {
              return (
                <option value={item.value} key={index}>
                  {item.text}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Flex>
      <Flex justifyContent={"space-evenly"} w={"100%"}>
        <Button
          bgColor={GRAY_DARK}
          color={WHITE}
          mt={4}
          onClick={() => {
            goToVendaBoletoListagem(navigate);
          }}
        >
          Fechar
        </Button>
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          isDisabled={
            loading ||
            cliente <= 0 ||
            valorConvertido <= 0 ||
            boleto.cpfPagador === "" ||
            boleto.nomePagador === "" ||
            boleto.enderCEP === "" ||
            boleto.enderRua === "" ||
            boleto.enderNumero === "" ||
            boleto.enderBairro === "" ||
            boleto.emailPagador === "" ||
            boleto.enderCidade === "" ||
            boleto.enderEstado === ""
          }
          mt={4}
          w={"600px"}
          onClick={onSubmit}
        >
          {loading ? <Spinner size="sm" /> : "Criar boleto de pagamento"}
        </Button>
      </Flex>
      <ModalRevisãoVendaBoleto
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        objeto={objetoModal}
        response={responseToModal && responseToModal}
      />
    </Flex>
  );
}
